import { FC, useEffect } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { observer } from 'mobx-react-lite'
import { useRpStandForm } from './useRpStandForm'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { WrapDrawerEditForm } from '../index'
import { TRpStandFormData } from './schema'
import RpStandFormBase from './base'
import { Prp2boxApiStands } from '../../prp2boxApi'
import { CreateRpStandPayload } from '../../prp2boxApi/stands'
import { useStore } from '../../stores'

type TRpStandFormEditProps = {
  id: string
}

const RpStandFormEdit: FC<TRpStandFormEditProps> = observer(({ id }) => {
  const { antMediaStore } = useStore()
  const queryClient = useQueryClient()
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
  } = useRpStandForm()

  useEffect(() => {
    ;(async () => {
      return antMediaStore.getList()
    })()
  }, [])

  const { data: entity } = useQuery([`get rpStand`, id], () => Prp2boxApiStands.getById(Number(id)), {
    onSuccess: (data) => {
      const { name, stream } = data
      reset({
        name,
        stream: stream.id,
      })
    },
    refetchOnWindowFocus: false,
  })

  const updateMutation = useMutation((payload: CreateRpStandPayload) => Prp2boxApiStands.update(Number(id), payload), {
    onSuccess: () => {
      toast.success('Стойка успешно обновлена')
      queryClient.invalidateQueries([EQueryKeysConstant.RP_STANDS])
    },
  })

  const handleSave = (data: TRpStandFormData) => {
    const { name, stream } = data

    updateMutation.mutate({
      name,
      stream: {
        id: stream,
        name: antMediaStore.findStreamNameById(data.stream),
      },
    })
  }

  return (
    <WrapDrawerEditForm
      title={`Редактирование стойки ${entity?.name || ''}`}
      onSave={handleSubmit(handleSave)}
      isShowSaveBtn
      isShowEditBtn={false}
      isShowDeleteBtn={false}
      isShowBlockBtn={false}
      busyText=""
      isBusy={false}>
      <RpStandFormBase
        register={register}
        errors={errors}
        control={control}
        streamOptions={antMediaStore.streamsOptions}
      />
    </WrapDrawerEditForm>
  )
})

export default RpStandFormEdit
